import TabCreazioneNota from './TabCreazioneNota.vue';
import TabDettaglioNote from './TabDettaglioNote.vue';
import TabVerificaNote from './TabVerificaNote.vue';
import TabVerificaAuto from './TabVerificaAuto.vue';
import TabVerificaTratta from './TabVerificaTratta.vue';
import TabReport from './TabReport.vue';
import TabReportMensile from './TabReportMensile.vue';
import TabReportMensileAdmin from './TabReportMensileAdmin.vue';
import TabPreautorizzato from './TabPreautorizzato.vue';
import TabNoteNonConfermate from './TabNoteNonConfermate.vue';
import ImgViewZoom from './ImgViewZoom.vue';
import CardNota from './CardNota.vue';
import Loading from './Loading.vue';
import Richieste from './Richieste.vue';
import Preautorizzato from './Preautorizzato.vue';
import TabRichieste from './TabRichieste.vue';
import TabStorico from './TabStorico.vue';

export {
    TabDettaglioNote,
    TabCreazioneNota,
    TabVerificaNote,
    TabVerificaAuto,
    TabVerificaTratta,
    TabReportMensile,
    TabReportMensileAdmin,
    TabNoteNonConfermate,
    ImgViewZoom,
    CardNota,
    TabReport,
    Loading,
    TabPreautorizzato,
    Richieste,
    Preautorizzato,
    TabRichieste,
    TabStorico
}


// WEBPACK FOOTER //
// ./modules/Home/views/src/components/index.js